import Vue from 'vue'
import App from './App.vue'

/******** BEUFY ********/
import Buefy from 'buefy'
Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'

import { store } from './store'
// import { apolloProvider } from '@/graphql/apollo'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('42d')

/******** ROUTES ********/
import router from './router'

/******** LAYOUTS ********/
import Default from "@/layouts/Default.vue";
import DefaultNoSidebar from "@/layouts/DefaultNoSidebar.vue";
import Auth from "@/layouts/Auth.vue";
import Landing from "@/layouts/Landing.vue";

Vue.component("default-layout", Default);
Vue.component("nosidebar-layout", DefaultNoSidebar);
Vue.component("auth-layout", Auth);
Vue.component("landing-layout", Landing);

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'waveDots'
  },
});

/******** VALIDATIONS ********/
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/******** DATES ********/
import moment from 'vue-moment'
Vue.use(moment)
import formatDate from '@/mixins/formatDate'
Vue.mixin(formatDate);

/******** ROLLBAR ********/
import Rollbar from 'rollbar'
if (process.env.NODE_ENV == 'production') {

  // Set the Rollbar instance in the Vue prototype
  // before creating the first Vue instance.
  // This ensures it is available in the same way for every
  // instance in your app.
  Vue.prototype.$rollbar = new Rollbar({
    accessToken: 'af13ccfa02354c0b9277c45ad22db84e',
    captureUncaught: true,
    captureUnhandledRejections: true,
    ignoredMessages: ["t: GraphQL error: Authentication Error"]
  });

  // If you have already set up a global error handler,
  // just add `vm.$rollbar.error(err)` to the top of it.
  // If not, this simple example will preserve the app’s existing
  // behavior while also reporting uncaught errors to Rollbar.
  Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
